import { module } from 'modujs'

const MAP_SOURCE_WIDTH = 1798;
const MAP_SOURCE_HEIGHT = 1531;

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)

        // UI
        this.$el = this.el
        this.$visual = this.$('visual')[0]

        // Data
        this.multiplier = MAP_SOURCE_WIDTH / MAP_SOURCE_HEIGHT
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()

        if (window.isFontsLoaded) {
            this.onFontsLoaded()
        }
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind)
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind)
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.computeMetrics()
    }

    onFontsLoaded() {
        this.computeMetrics()
    }

    ///////////////
    // Methods
    ///////////////
    computeMetrics() {
        const elHeight = this.$el.offsetHeight
        const width = Math.floor(this.multiplier * elHeight)
        this.$visual.style.setProperty('--map-width', width)
    }
}